var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "document",
    "data-name": "document",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "document-1",
    d: "M169.56,0H24.65V256h206.7V61.78ZM174,25.92l31.41,31.42H174ZM40.62,240.81V15.19h118.2V72.52h57.34v51.79h-.69v15h.69v101.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "document-1",
    x: 74.29,
    y: 108.48,
    width: 108.26,
    height: 15.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "document-1",
    x: 74.29,
    y: 139.4,
    width: 108.26,
    height: 15.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "document-1",
    x: 73.87,
    y: 171.81,
    width: 108.26,
    height: 15.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.959eaa32.svg";
export { ForwardRef as ReactComponent };